export const NO_FILE_UPLOADED: string = 'No file uploaded'
